import { GET_DEPT_LIST, EDIT_DEPT, ADD_DEPT } from 'fixtures/actions'
import { GET_DEPTS, GET_DEPTS_BY_COMPANY, GET_DEPTS_NON_SEGREGATE } from 'fixtures/api'
import { getAllList } from 'services/cmsService'

const getAllDeptsData = () => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(GET_DEPTS)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_DEPT_LIST,
      payload: data
    })
  }
}

const getAllDeptsOptionData = () => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(GET_DEPTS_NON_SEGREGATE)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_DEPT_LIST,
      payload: data
    })
  }
}

const resetDeptsData = () => {
  return dispatch => dispatch({
    type: GET_DEPT_LIST,
    payload: []
  })
}

const getDeptsDataByCompany = (ids = [], query = {}) => {
  return async dispatch => {
    let data = []
    let additionalQuery = Object.entries(query)
    .map(([k, v]) => `${k}=${v}`)
    .join('&');

    let newData = await getAllList(`${GET_DEPTS_BY_COMPANY(ids)}${additionalQuery ? `&${additionalQuery}` : ''}`)
    if (newData) {
      data = newData
    }

    dispatch({
      type: GET_DEPT_LIST,
      payload: data
    })
  }
}

const editDeptData = (data) => {
  return (dispatch) => {
    dispatch({
      type: EDIT_DEPT,
      payload: data
    })
  }
}

const addDeptData = (data) => {
  return (dispatch) => {
    dispatch({
      type: ADD_DEPT,
      payload: data
    })
  }
}

export { getAllDeptsData, getAllDeptsOptionData, resetDeptsData, getDeptsDataByCompany, editDeptData, addDeptData }
